"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./App.scss");
const react_router_dom_1 = require("react-router-dom");
const MyEquipmentPage_1 = __importDefault(require("./pages/MyEquipmentPage"));
const ReportPage_1 = __importDefault(require("./pages/ReportPage"));
const SearchUniformsPage_1 = __importDefault(require("./pages/SearchUniformsPage"));
function App() {
    return (react_1.default.createElement(react_router_dom_1.BrowserRouter, null,
        react_1.default.createElement(react_router_dom_1.Routes, null,
            react_1.default.createElement(react_router_dom_1.Route, { path: "/la-mia-dotazione", element: react_1.default.createElement(MyEquipmentPage_1.default, null) }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "/segnalazione/:id", element: react_1.default.createElement(ReportPage_1.default, null) }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "/ricerca-divisa/:id", element: react_1.default.createElement(SearchUniformsPage_1.default, null) }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "/ricerca-divisa/", element: react_1.default.createElement(SearchUniformsPage_1.default, null) }))));
}
exports.default = App;
